import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "addressContainer" }
const _hoisted_2 = {
  key: 0,
  class: "boxTitle"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_5 = { class: "form-group col-sm-10" }
const _hoisted_6 = {
  key: 0,
  class: "form-control"
}
const _hoisted_7 = { class: "form-group col-sm-2" }
const _hoisted_8 = {
  key: 0,
  class: "form-control"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "form-group col-md-4" }
const _hoisted_11 = {
  key: 0,
  class: "form-control"
}
const _hoisted_12 = { class: "form-group col-md-4" }
const _hoisted_13 = {
  key: 0,
  class: "form-control"
}
const _hoisted_14 = { class: "form-group col-md-4" }
const _hoisted_15 = {
  key: 0,
  class: "form-control"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "form-group col-8" }
const _hoisted_18 = {
  key: 0,
  class: "form-control"
}
const _hoisted_19 = { class: "form-group col-4" }
const _hoisted_20 = {
  key: 0,
  class: "form-control"
}
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  key: 0,
  class: "form-control"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  key: 0,
  class: "form-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_autocomplete = _resolveComponent("google-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_google_autocomplete, {
              modelValue: _ctx.googleAddress,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.googleAddress) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Via", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.localValue.via || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.via) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.via]
            ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Civico", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.localValue.civico || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.civico) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.civico]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, "Città", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.localValue.citta || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.citta) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.citta]
            ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Regione", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.localValue.regione || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.regione) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.regione]
            ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[14] || (_cache[14] = _createElementVNode("label", null, "Nazione", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.localValue.nazione || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.nazione) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.nazione]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Provincia", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.localValue.provincia || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.provincia) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.provincia]
            ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[16] || (_cache[16] = _createElementVNode("label", null, "CAP", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.localValue.cap || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.cap) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.cap]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[17] || (_cache[17] = _createElementVNode("label", null, "Scala, piano, interno ecc.", -1)),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.localValue.scalaPianoInterno || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.scalaPianoInterno) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.scalaPianoInterno]
          ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _cache[18] || (_cache[18] = _createElementVNode("label", null, "Note di contatto", -1)),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.localValue.note || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localValue.note) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.note]
          ])
    ])
  ]))
}